import { useState, Fragment, useRef, useEffect } from "react";
import moment from "moment";
import { postDataWithDotNet } from "../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import Alert from "../../../NewComponents/Alert/Alert.component";
import { errorHandler } from "../../../helpers/errorHandler";
import { useHistory, useLocation } from "react-router-dom";
import ApprovalInvestorModal from "../ApprovalRequests/ApprovalInvestorModal";
import BackButtonComponent from "../../../NewComponents/BackButton/BackButton.component";
import { formatMoney } from "../../../helpers/formatter";
import { appInsights } from "../../../config/appInsights";

export default function PreviewInvesmentFundDetails(props) {
  const [modalActionType, setModalActionType] = useState("");
  const [modifier, setModifier] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [saveError, setSaveError] = useState(null);
  const [activateState, setActivateState] = useState({
    comment: "",
  });

  useEffect(() => {
    appInsights.trackPageView({
      name: "Preview Investment Fund Details - (PreviewInvesmentFundDetails.jsx)",
      isLoggedIn: true,
    });
  }, []);

  const location = useLocation();
  const { data, mifosData } = location?.state;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setActivateState({ ...activateState, [name]: value });
  };

  const dismissModalRef = useRef();
  const history = useHistory();

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    const reqBody = {
      reference: data?.reference,
      comment: activateState.comment,
    };
    try {
      const response = await postDataWithDotNet(
        `${ajaxEndpoints.APPROVE_PENDING_INVESTMENT_PRODUCT}`,
        reqBody
      );
      setLoading(false);
      if (dismissModalRef && dismissModalRef.current) {
        dismissModalRef.current.click();
      }
      setSuccessMessage(response.message);
      setTimeout(() => {
        history.push("/approval-requests");
      }, 3000);
    } catch (error) {
      appInsights.trackException({
        exception: error,
        properties: {
          fileName: "PreviewInvesmentFundDetails.jsx",
        },
      });
      setLoading(false);
      if (dismissModalRef && dismissModalRef.current) {
        dismissModalRef.current.click();
      }
      setSaveError(errorHandler(error));
      setActivateState({ comment: "" });
      setTimeout(() => {
        history.push("/approval-requests");
      }, 3000);
    }
  };
  const handleDecline = async (e) => {
    setLoading(true);
    e.preventDefault();
    const reqBody = {
      reference: data?.reference,
      comment: activateState.comment,
    };
    try {
      const response = await postDataWithDotNet(
        `${ajaxEndpoints.REJECT_REQUEST}`,
        reqBody
      );
      setLoading(false);
      if (dismissModalRef && dismissModalRef.current) {
        dismissModalRef.current.click();
      }
      setSuccessMessage(response.message);
      setTimeout(() => {
        history.push("/approval-requests");
      }, 3000);
    } catch (error) {
      appInsights.trackException({
        exception: error,
        properties: {
          fileName: "PreviewInvesmentFundDetails.jsx",
        },
      });
      setLoading(false);
      if (dismissModalRef && dismissModalRef.current) {
        dismissModalRef.current.click();
      }
      setSaveError(errorHandler(error));
      setActivateState({ comment: "" });
      setTimeout(() => {
        history.push("/approval-requests");
      }, 3000);
    }
  };

  const discardChanges = (e) => {
    e.preventDefault();
    if (dismissModalRef && dismissModalRef.current) {
      dismissModalRef.current.click();
    }
  };
  let RenderedComponent = null;
  if (
    (mifosData && data && data.lcyCorebankingId) ||
    (mifosData && data && data.usdCorebankingId)
  ) {
    if (mifosData && data && data.lcyCorebankingId) {
      const lcyData = mifosData.filter(
        (eachData) => eachData.id === Number(data.lcyCorebankingId)
      );
      RenderedComponent = (
        <div className="col-md-12 mb-3">
          <h6>Naira Core Banking Product</h6>
          <p className="page-subtitle">{lcyData[0]?.name || "N/A"}</p>
        </div>
      );
    }
    if (mifosData && data && data.usdCorebankingId) {
      const lcyData = mifosData.filter(
        (eachData) => eachData.id === Number(data.usdCorebankingId)
      );
      RenderedComponent = (
        <div className="col-md-12 mb-3">
          <h6>Dollar Core Banking Product</h6>
          <p className="page-subtitle">{lcyData[0]?.name || "N/A"}</p>
        </div>
      );
    }
  }
  return (
    <Fragment>
      <div className="animated fadeInRight mt-2">
        <h3 className="page-title d-flex align-items-center">
          <BackButtonComponent />
        </h3>
        <div className="d-flex flex-row flex-wrap  mt-3 mb-1">
          {saveError && <Alert message={saveError} />}
          {successMessage && <Alert message={successMessage} type="success" />}
          <h3 className="page-title">{data?.name}</h3>

          <div className="d-flex flex-row flex-wrap ">
            <button
              className="btn advancly-btn btn-md mr-3"
              disabled={loading}
              data-toggle="modal"
              data-target="#approvalRequestModal"
              onClick={() => {
                setModalActionType("approve");
                setModifier("investment");
              }}
            >
              Approve
            </button>
            <button
              className="btn advancly-dimred-btn btn-md m-0"
              disabled={loading}
              data-toggle="modal"
              data-target="#approvalRequestModal"
              onClick={() => {
                setModifier("investment");
                setModalActionType("decline");
              }}
            >
              Decline
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-8">
            <h3 className="page-subtitle">Investment Details</h3>
            <hr
              style={{
                width: "63%",
                marginLeft: 0,
                marginBottom: "30",
              }}
            ></hr>
            <div className="col-md-12 mb-3">
              <h6>Currency</h6>
              <p className="page-subtitle">
                {data?.investment_type === 1 || data?.investment_type === "1"
                  ? "Naira"
                  : data?.investment_type === 2 || data?.investment_type === "2"
                  ? "Dollar"
                  : data?.investment_type === 3 || data?.investment_type === "3"
                  ? "Naira, Dollar"
                  : "N/A"}
              </p>
            </div>
            <div className="col-md-6 mb-3">
              <h6>Start Date</h6>
              <p className="page-subtitle">
                {data?.startDate
                  ? moment(data?.startDate).format("DD/MM/YYYY")
                  : "N/A"}
              </p>
            </div>
            <div className="col-md-6 mb-3">
              <h6>End Date</h6>
              <p className="page-subtitle">
                {data?.endDate
                  ? moment(data?.endDate).format("DD/MM/YYYY")
                  : "N/A"}
              </p>
            </div>

            <h3 className="page-subtitle mt-4">Financials</h3>
            <hr
              style={{
                width: "63%",
                marginLeft: 0,
                marginBottom: "30",
              }}
            ></hr>
            {(data?.investment_type === 1 || data?.investment_type === "1") && (
              <>
                <div className="col-md-12 mb-3">
                  <h6>Naira (Min - Max Investment)</h6>
                  <p className="page-subtitle">
                    {formatMoney(data?.lcyMinimumInvestment, "#")} -{" "}
                    {formatMoney(data?.lcyMaximumInvestment, "#")}
                  </p>
                </div>
                <div className="col-md-12 mb-3">
                  <h6>Naira Investment Size</h6>
                  <p className="page-subtitle">
                    {formatMoney(data?.lcyInvestmentSize, "#") || "N/A"}
                  </p>
                </div>
              </>
            )}
            {(data?.investment_type === 2 || data?.investment_type === "2") && (
              <>
                <div className="col-md-12 mb-3">
                  <h6>Dollar (Min - Max Investment)</h6>
                  <p className="page-subtitle">
                    {formatMoney(data?.usdMinimumInvestment, "$")}{" "}
                    {formatMoney(data?.usdMaximumInvestment, "$")}
                  </p>
                </div>
                <div className="col-md-12 mb-3">
                  <h6>Dollar Investment Size</h6>
                  <p className="page-subtitle">
                    {formatMoney(data?.usdInvestmentSize, "$") || "N/A"}
                  </p>
                </div>
              </>
            )}
            {(data?.investment_type === 3 || data?.investment_type === "3") && (
              <>
                <div className="col-md-12 mb-3">
                  <h6>Naira (Min - Max Investment)</h6>
                  <p className="page-subtitle">
                    {formatMoney(data?.lcyMinimumInvestment, "#")} -{" "}
                    {formatMoney(data?.lcyMaximumInvestment, "#")}
                  </p>
                </div>

                <div className="col-md-12 mb-3">
                  <h6>Naira Investment Size</h6>
                  <p className="page-subtitle">
                    {formatMoney(data?.lcyInvestmentSize, "#") || "N/A"}
                  </p>
                </div>
                <div className="col-md-12 mb-3">
                  <h6>Dollar (Min - Max Investment)</h6>
                  <p className="page-subtitle">
                    {formatMoney(data?.usdMinimumInvestment, "$")} -{" "}
                    {formatMoney(data?.usdMaximumInvestment, "$")}
                  </p>
                </div>
                <div className="col-md-12 mb-3">
                  <h6>Dollar Investment Size</h6>
                  <p className="page-subtitle">
                    {formatMoney(data?.usdInvestmentSize, "$") || "N/A"}
                  </p>
                </div>
              </>
            )}
            {RenderedComponent}
          </div>
        </div>
      </div>

      <ApprovalInvestorModal
        onSubmit={handleSubmit}
        onDecline={handleDecline}
        discardChanges={discardChanges}
        modalActionType={modalActionType}
        dismissModalRef={dismissModalRef}
        loading={loading}
        handleChange={handleChange}
        modifier={modifier}
      />
    </Fragment>
  );
}
